import { useEffect,useState } from 'react';
import styled from 'styled-components';

import { PromotionBannerProps } from '../types';

export const SimpleBanner: React.FC<PromotionBannerProps> = ({ onClick, mode }) => {
  const [timeLeft, setTimeLeft] = useState<{ hours: number; minutes: number; seconds: number }>({
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const getRemainingTime = () => {
    if (!mode.dateEnd || !mode.dateStart) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    const dateEnd = new Date(mode.dateEnd).getTime();
    const currentTime = Date.now();
    const remainingTime = dateEnd - currentTime;

    const totalSeconds = Math.max(Math.floor(remainingTime / 1000), 0);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { hours, minutes, seconds };
  };

  const updateTimer = () => {
    const { hours, minutes, seconds } = getRemainingTime();
    setTimeLeft({ hours, minutes, seconds });

    const triggerTime = hours === 0 && minutes === 5 && seconds === 0;

    if (triggerTime) {
      onClick();
    }
  };

  useEffect(() => {
    updateTimer();

    const timerId = setInterval(updateTimer, 1000);

    return () => {
      clearInterval(timerId);
    };
  }, []);

  const formattedTime = {
    hours: String(timeLeft.hours).padStart(2, '0'),
    minutes: String(timeLeft.minutes).padStart(2, '0'),
    seconds: String(timeLeft.seconds).padStart(2, '0')
  };

  return (
    <Banner onClick={onClick}>
      <CommonContainer>
        <CenterContainer>
          <CenterText>
            <UpperText>{mode.banner.titleText}</UpperText>
          </CenterText>
        </CenterContainer>

        <TimerContainer>
          <TimerItem>
            {formattedTime.hours}
            <Label>hr</Label>
          </TimerItem>
          <DoubleDot>:</DoubleDot>
          <TimerItem>
            {formattedTime.minutes}
            <Label>min</Label>
          </TimerItem>
          <DoubleDot>:</DoubleDot>
          <TimerItem>
            {formattedTime.seconds}
            <Label>sec</Label>
          </TimerItem>
        </TimerContainer>
      </CommonContainer>
    </Banner>
  );
};

const Banner = styled.div<React.PropsWithChildren<{ onClick: () => void }>>`
  height: 60px;
  width: 100%;
  position: fixed;
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
  z-index: 100;
  cursor: pointer;
`;

const CommonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
`;

const CenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  /* width: 225px; */
  padding: 0 180px;

  @media (max-width: 768px) {
    font-size: 12px;
    padding-left: 0;
  }
  @media (max-width: 470px) {
    font-size: 12px;
    padding-right: 140px;
  }
`;

const CenterText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px;

  @media (max-width: 470px) {
    margin: 0;
  }
`;

const UpperText = styled.p`
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  text-align: center;
  color: #ffffff;
  height: 100%;

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 15px;
  }
`;

const TimerContainer = styled.div`
  position: absolute;
  right: 50px;
  top: 8px;

  width: 123px;
  height: 44px;
  padding: 6px 12px;
  gap: 6px;
  border-radius: 12px;
  background-color: #100d0b80;
  margin-right: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  @media (max-width: 470px) {
    margin-right: 10px;
    right: 10px;
  }
`;

const DoubleDot = styled.span`
  height: 42px;
  align-items: center;
`;

const TimerItem = styled.div`
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  color: white;
`;

const Label = styled.div`
  margin-top: 1px;
  font-size: 12px;
  color: #a9a9a9;
`;
